import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sf-table tw-text-left"
}
const _hoisted_2 = ["value", "id"]
const _hoisted_3 = ["for"]
const _hoisted_4 = { class: "tw-text-right" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_7 = { class: "tw-text-right" }
const _hoisted_8 = { class: "tw-text-right" }
const _hoisted_9 = { class: "tw-font-bold" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-right" }, "Total", -1)
const _hoisted_13 = { class: "tw-text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.costs)
    ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productsAvailable, (p) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: p.name
            }, [
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.products) = $event)),
                  value: p.kind,
                  id: 'pcb-' + p.name
                }, null, 8, _hoisted_2), [
                  [_vModelCheckbox, _ctx.products]
                ])
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("label", {
                  class: "first-letter:tw-uppercase",
                  for: 'pcb-' + p.name
                }, _toDisplayString(p.label), 9, _hoisted_3)
              ]),
              _createElementVNode("td", null, _toDisplayString(_ctx.$filters.longDateFormat(p.period?.start, false)) + " - " + _toDisplayString(_ctx.$filters.longDateFormat(p.period?.end, false)), 1),
              _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.$filters.renderMoney(p.cost)), 1)
            ]))
          }), 128)),
          _createElementVNode("tr", null, [
            _hoisted_5,
            _hoisted_6,
            _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.costs.comboDiscount.label), 1),
            _createElementVNode("td", _hoisted_8, " -" + _toDisplayString(_ctx.$filters.renderMoney(_ctx.discount)), 1)
          ]),
          _createElementVNode("tr", _hoisted_9, [
            _hoisted_10,
            _hoisted_11,
            _hoisted_12,
            _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.$filters.renderMoney(_ctx.total)), 1)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}